import { create } from 'zustand';
import { CartItem, CartItemDTO, toCartItem } from '../types/Cart';
import { executeDelete, executeFetch, executePost, executePut } from '../helper/Api';
import Cookies from 'js-cookie';


interface StoreState {
  cart: CartItemDTO[]; 
  getCart : () => void;
  addToCart: (cartItem: CartItemDTO) => void;
  removeFromCart: (id: string) => void;
  updateCart : (cartItem: CartItemDTO) => void;
}


const useCartStore = create<StoreState>((set) => ({
  cart: [],
  getCart: async () => {
    set({ cart: [] as CartItem[]});
    const hasToken = Cookies.get('token') !== undefined;
    if(hasToken){
    try {
        const resp = await executeFetch<CartItemDTO[]>(`Cart/GetUserCart`,{auth:'auth'})
      if(resp.error){
          console.error(resp.error.message)
      }else{
        set({ cart: resp.data as CartItem[]});
      }
    } catch (error) {
      console.error("Error fetching products:", error);
      
    }
  }else{
    set({ cart: [] as CartItem[]});
  }
  },
  addToCart: async (newItem: CartItemDTO) => {
    try {
      const state = useCartStore.getState();
      const existingItem = state.cart.find(item => item.productId === newItem.productId);
  
      if (existingItem) {
        // If item with same SKU exists, update quantity
        const updatedItem: CartItemDTO = {
          ...existingItem,
          quantity: existingItem.quantity + newItem.quantity,
        };
  
        const resp = await executePut<CartItemDTO, CartItemDTO>(
          `Cart/UpdateCartItem`,
          updatedItem,
          { auth: 'auth' }
        );
  
        if (resp.error) {
          console.error(resp.error.message);
        } else {
          set((state) => ({
            cart: state.cart.map(item =>
              item.id === resp.data.id ? { ...resp.data } : item
            ),
          }));
        }
      } else {
        const resp = await executePost<CartItemDTO, CartItemDTO>(
          `Cart/AddToCart`,
          newItem,
          { auth: 'auth' }
        );
  
        if (resp.error) {
          console.error(resp.error.message);
        } else {
          set((state) => ({
            ...state,
            cart: [...state.cart, resp.data],
          }));
        }
      }
    } catch (error) {
      console.error("Error adding cart item:", error);
      throw error;
    }
  },
  removeFromCart: async (id : string) =>{
    try{
  const resp = await executeDelete(`Cart/DeleteCartItem`,id,{auth:'auth'})
  if(resp.error){
    console.error(resp.error.message)
  }else{
    set((state) => ({
      ...state,
      cart: state.cart.filter(item => item.id !== id)
    }));
  }
} catch (error) {
  console.error("Error deleting cart item:", error);
  throw error;
}
},
 updateCart: async (cartItem : CartItemDTO) => {
  try {
    const resp = await executePut<CartItemDTO,CartItemDTO>(`Cart/UpdateCartItem`,cartItem,{auth:'auth'})
    if(resp.error){
      console.error(resp.error.message)
    }else{
      set((state) => ({
        cart: state.cart.map(item =>
          item.id === resp.data.id ? { ...resp.data } : item
        )
      }));
    }
  } catch (error) {
    console.error("Error updating cart item:", error);
    throw error;
  }
},

}));

export default useCartStore;